import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import styles from "styles/component/Dragdropfile.module.scss";
import { Box, Button, Grid } from "@mui/material";
import asset from "json/assets";
import useNotiStack from "hooks/useNotistack";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import NoificationModal from "pages/ModalPage/NoificationModal";
import { getModalProperties } from "services/utils";

const DragDropFileInput = (props) => {
  const { name, onChange,coursescoreCardImg,removeImgFile } = props;
  const uploadedFilenames =[];
  const [files, setFiles] = useState([]);
  const [openWarnModal, setOpenWarnModal] = useState(false)
  const [selectedImageFile, setselectedImgFile] = useState();

  const {  toastError } = useNotiStack();
  const modalProperties = getModalProperties();

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
  if (acceptedFiles?.length) {
    for (const file of acceptedFiles) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const previewUrl = reader.result;
        setFiles((previousFiles) => [
          ...previousFiles,
          Object.assign(file, { preview: previewUrl }),
        ]);
      };
      reader.readAsDataURL(file);
    }
  }

  if (rejectedFiles?.length && rejectedFiles[0]?.errors[0]?.code === "file-too-large") {
    toastError("File size is larger than 1 MB")
  } else if(rejectedFiles[0]?.errors[0]?.code === "file-invalid-type"){
    toastError("File type must be image.")
  }
}, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "image/*": [],
    },
    maxSize: 1* 1024 * 1024,

    onDrop,
  });


  const removeFile = (name,id_image) => {
      //  setFiles((files) => files.filter((file) => file.name !== name)); 
      setOpenWarnModal(true)
      setselectedImgFile({name,id_image})
  };
  const handleDeleteImage = ()=> {
    removeImgFile(selectedImageFile)
    setFiles((files) => files.filter((file) => file.name !== selectedImageFile?.name));
    setOpenWarnModal(false)
  }
  
  useEffect(() => {
    if (files) {
      onChange(files);
    }

     // Revoke the data uris to avoid memory leaks
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);
  
    const courseImgPreviewFiles = useMemo(()=> {
      const modifiedcoursescoreCardImg = coursescoreCardImg?.map(item => ({
        ...item,
        name: item?.id_image,
        preview: item?.imageUrl
     }));
     if (modifiedcoursescoreCardImg) {
      setFiles([...modifiedcoursescoreCardImg]);
    }
    return modifiedcoursescoreCardImg;
      },[coursescoreCardImg])

 
  return (
    <div className={styles.dragField}>

      <div {...getRootProps({})}>
        <input 
        // id={name} 
        {...getInputProps()} />

        <div
          className={
            "w-full p-2 border border-dashed border-gray-900 " +
            (isDragActive ? "bg-gray-400" : "bg-gray-200")
          }
        >{files?.length >= 0 && files?.length < 4 && <p className={styles.dragInput}>CLICK OR DRAG SCORECARD IMAGES TO UPLOAD TO DATABASE</p>}
          
        </div>
      </div>
    
      <Box className={styles.uploadGrid}>
        <Box className={styles.uploadGrid_inr}>
          {files.map((file) => {
            return (
              <Box key={file.name} className={styles.each_img}>
                <figure>
                  <a href={file.preview} target="_blank" rel="noopener noreferrer">
                    <img src={file.preview} alt={file.name} style={{ cursor: "pointer" }} />
                  </a>
                    <Button
                      className={styles.removeicon}
                      onClick={() => removeFile(file.name,file?.id_image)}
                    >
                      {" "}
                      <img src={asset.close} alt="" />
                    </Button>
                </figure>
              </Box>
            );
          })}
        </Box>

        
      </Box>
      
      <ModalWrapper
        open={openWarnModal}
        onClose={()=> setOpenWarnModal(false)}
        handleClose={()=> setOpenWarnModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NoificationModal
          label="Warning"
          backgroundColor={modalProperties.info.backgroundColor}
          image={modalProperties.warning.icon}
          title={`<span style='font-size:14px'>Are you sure you want to delete this
                <br/> image?
               </span>`}
          content="This cannot be undone."
          rejCallBack={()=> setOpenWarnModal(false)}
          affrCallBack={handleDeleteImage}
        />
      </ModalWrapper>
    </div>
  );
};

export default DragDropFileInput;
